export function isEmptyOrNull(str: string): boolean {
  return !str || str.length === 0 || str.trim().length === 0;
}

/**
 * Capitalizes the first letter of each word in the given string.
 * Unlike lodash's `startCase`, this function does not add spaces at alphanumeric boundaries;
 * it only capitalizes the first character of each word as determined by word boundaries.
 *
 * @param str - The input string to capitalize.
 * @returns The string with the first letter of each word capitalized.
 */
export const capitalizeWords = (str: string): string => {
  if (isEmptyOrNull(str)) return '';
  return str.replace(/\b\w/g, char => char.toUpperCase());
};
